import HydrodigitalLogoSvg from '@/assets/img/hydrodigital-logo.svg?url';

interface HydrodigitalLogoProps {
	onClick?: () => void;
	size?: 'sm' | 'md' | 'lg' | 'xl';
	className?: string;
	alt?: string;
}

const sizeClasses = {
	sm: 'w-32',   
	md: 'w-44',    
	lg: 'w-56',    
	xl: 'w-64',    
};

function HydrodigitalLogo({
	onClick,
	size = 'lg',
	className = '',
	alt = 'Hydrodigital Logo',
}: HydrodigitalLogoProps) {
	const baseClasses = 'transition-opacity duration-200 hover:opacity-80';
	const cursorClass = onClick ? 'cursor-pointer' : 'cursor-default';
	const sizeClass = sizeClasses[size];
	
	const allClasses = [baseClasses, cursorClass, sizeClass, className]
		.filter(Boolean)
		.join(' ');

	return (
		<img
			src={HydrodigitalLogoSvg}
			alt={alt}
			className={allClasses}
			onClick={onClick}
		/>
	);
}

export default HydrodigitalLogo;